export const CompanyDocTypes = Object.freeze({
    AML_CFT_COMPLIANCE_POLICY_AND_PROCEDURES: "AML_CFT_COMPLIANCE_POLICY_AND_PROCEDURES",
    APPLICATION_FORM: "APPLICATION_FORM",
    CERTIFICATE_OF_GOOD_STANDING: "CERTIFICATE_OF_GOOD_STANDING",
    CERTIFICATE_OF_INCORPORATION_OR_REGISTRATION: "CERTIFICATE_OF_INCORPORATION_OR_REGISTRATION",
    COMPANY_PROOF_OF_ADDRESS: "COMPANY_PROOF_OF_ADDRESS",
    CRYPTO_CURRENCY_QUESTIONNAIRE: "CRYPTO_CURRENCY_QUESTIONNAIRE",
    DIRECTORS_REGISTER_CERTIFICATE: "DIRECTORS_REGISTER_CERTIFICATE",
    DOMAIN_PROOF: "DOMAIN_PROOF",
    FINANCIAL_STATEMENTS: "FINANCIAL_STATEMENTS",
    MEMORANDUM_OF_ASSOCIATION_OR_ARTICLES_OF_INCORPORATION: "MEMORANDUM_OF_ASSOCIATION_OR_ARTICLES_OF_INCORPORATION",
    OPERATION_LICENSE: "OPERATION_LICENSE",
    ORGANISATION_CHART: "ORGANISATION_CHART",
    PROOF_OF_ADDRESS: "PROOF_OF_ADDRESS",
    RECENT_CERTIFICATE_OF_INCUMBENCY: "RECENT_CERTIFICATE_OF_INCUMBENCY",
    SHAREHOLDERS_REGISTER: "SHAREHOLDERS_REGISTER",
    TRADING_BANK_STATEMENTS: "TRADING_BANK_STATEMENTS",
    WOLFSBERG_S_QUESTIONNAIRE: "WOLFSBERG_S_QUESTIONNAIRE",
    OTHER: "OTHER",
    LICENSES_AND_PERMITS: "LICENSES_AND_PERMITS",
    CONTRACTUAL_DOCUMENTS: "CONTRACTUAL_DOCUMENTS",
    INSURANCE_CERTIFICATES: "INSURANCE_CERTIFICATES"
});

export const CompanyDocTypeLabels = Object.freeze({
    AML_CFT_COMPLIANCE_POLICY_AND_PROCEDURES: "AML/CFT Compliance Policy & Procedures",
    APPLICATION_FORM: "Application Form",
    CERTIFICATE_OF_GOOD_STANDING: "Certificate of Good Standing",
    CERTIFICATE_OF_INCORPORATION_OR_REGISTRATION: "Certificate of Incorporation / Registration",
    COMPANY_PROOF_OF_ADDRESS: "Company Proof of Address",
    CRYPTO_CURRENCY_QUESTIONNAIRE: "Crypto Currency Questionnaire",
    DIRECTORS_REGISTER_CERTIFICATE: "Directors Register Certificate",
    DOMAIN_PROOF: "Domain Proof",
    FINANCIAL_STATEMENTS: "Financial Statements",
    MEMORANDUM_OF_ASSOCIATION_OR_ARTICLES_OF_INCORPORATION: "Memorandum of Association / Articles of Incorporation",
    OPERATION_LICENSE: "Operation License",
    ORGANISATION_CHART: "Organisation Chart",
    PROOF_OF_ADDRESS: "Proof of Address",
    RECENT_CERTIFICATE_OF_INCUMBENCY: "Recent Certificate of Incumbency",
    SHAREHOLDERS_REGISTER: "Shareholders Register",
    TRADING_BANK_STATEMENTS: "Trading Bank Statements",
    WOLFSBERG_S_QUESTIONNAIRE: "Wolfsberg Questionnaire",
    OTHER: "Other",
    LICENSES_AND_PERMITS: "Licenses and Permits",
    CONTRACTUAL_DOCUMENTS: "Contractual Documents",
    INSURANCE_CERTIFICATES: "Insurance Certificates"
});

export const getCompanyDocTypeLabel = (type) => {
    if (!type) return "";
    return CompanyDocTypeLabels[type] || type
        .split("_")
        .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
        .join(" ");
};
